/**
 * Dashboard Registry — central list of all registered dashboard plugins.
 *
 * Each plugin implements DashboardPlugin and is added to this array.
 * The DashboardComponent renders the selected plugin from this registry.
 */

import type { DashboardPlugin } from "./types";
import { spbAnalyticsDashboard } from "./plugins/spbAnalytics";

export const dashboardRegistry: DashboardPlugin[] = [spbAnalyticsDashboard];
